/* eslint-disable quotes */
// Japonês
export const japones = {
  start: "スタート",
  configurations: "設定",
  ramdom: "ランダム再生",
  vibration: "振動:",
  startgame: "ゲーム開始",
  save: "セーブ",
  delete: "削除",
  update: "更新情報",
  lets: "プレイしよう",
  permanentbuy: "恒久購入品",
  signature: "月極め購読",
  signatureano: "年間購読",
  small: "ここでは、本名でもニックネームでも構いません。",
  text1: "プレミアムアクセス権を取得し、すべてのアップデートを保証する",
  text2: "ご契約いただくと、いつでもプレミアム版にアクセスできます。",
  gender: "ジェンダー",
  male: "男  ",
  female: "女性",
  ambos: "両方の",
  fechar: "閉じる",
  sexualorientation: "性的指向",
  heterosexual: "ヘテロセクシャル",
  homosexual: "ホモセクシャル",
  bisexual: "バイセクシャル",
  chooseavatar: "アバターを選ぶ",
  Participants: "参加者",
  participant: "参加者登録",
  name: "名称",
  choosecategory: "カテゴリーを選択",
  categories: "カテゴリー",
  light: "光",
  preliminary: "性的前戯",
  oral: "経口",
  anal: "アナル",
  hot: "ホット",
  extreme: "エクストリーム",
  vd: "真実  ?",
  dare: "チャレンジ ?",
  truth: "真実",
  time: "時間",
  createMyChallenges: "マイ・チャレンジの作成",
  chosen: "選択した",
  text3: "あなたの中に愛を流れ込ませてください",
  text4: "激しく生きるための準備をする",
  close: "閉じる",
  sele: "オプションを選択する",
  dev: "開発：Dev12BR",
  game: "マッチ",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "次ページ",
  config1: "なぜプレミアム版を購入する必要があるのですか？",
  config2: "専用カテゴリーと800以上の新チャレンジ",
  config3: "広告なし",
  config4: "アバターを選んで強化",
  config5: "自分なりの課題を作る ",
  config6: "ゲーム開発をサポートする",
  config7: "ゲームにコストをかける理由",
  config8:
    "ゲームを開発するには、時間が必要です :) このようにして、ゲームをサポートし、常にゲームを改善し、アップデートすることに貢献することができるのです。",
  config9: "独自のチャレンジを作成・編集する",
  age: `このゲームは成人向けですので、18歳以上の方が対象です。はい」を選択することにより、お客様は利用規約およびプライバシーポリシーに同意したことになります。

  このゲームはカップル向けなので、最低でも1人のパートナーと一緒にプレイしてください。
  
  出会い系アプリではなく、相手と一緒に遊ぶためのものです。
    `,
  config10: "独占カテゴリー",
  config11: "+ 800の新しい挑戦",
  assessment:
    "アプリについてコメントを添えて、評価をお願いします。ゲームをより良いものにするために、皆様からのご意見は大変重要です。",
  agree: "はい、18歳以上です",
  noAgree: "アプリケーションを閉じる",
  apoio1: "プレミアム版の購読による開発支援 :)",
  apoio2: "ショップでアプリを評価するのを忘れないでください S2",
  apoio3: "プレミアム版のすべての限定機能を利用することができます。",
  apoio4: "このバナーを消す - プレミアムバージョンを購入する",
  version: "プレミアムバージョン",
  version1: "プレミアムバージョン",
  alert1: "プレイするユーザーを登録",
  alert2: "プレイするユーザーを1人以上登録する",
  alert3: "少なくとも1つのカテゴリーを選択する",
  alert4: `🔥 パートナーのいない参加者もいる。男女各2名以上参加すること 🔞. 
        
例：異性愛者2人、同性愛者2人。`,
  tituloAlert1: "⚠️ ゲームが始まろうとしています 😜",
  tituloAlert2:
    "⚠️ 残念😬、インターネット📶がないんですね。デバイスでインターネットをオンにし、サブスクリプション、つまり究極のプランを購入します。そして、幸せになってください😘。",
  parser: "パートナーなし",
  premiumImages:
    "プレミアムになると、より多くのアバターが利用できるようになります。",
  duvidas: "質問または提案 - Spicy Challenges",
  description: "こんにちは、私の質問または提案です。",
  texto99:
    "問題点、質問、提案などがありましたら、下のこのボタンをクリックして、メールをお送りください。ぜひ、お話をお聞かせください。",
  send: "送信 ✉️",
  contact: "お問い合わせ先",
  botaoApple: "購入した商品の復元",
  alertCompra: "購入した製品が復元される",
  NotPurchase: "購入履歴がない",
  notPurchase2:
    "このリンクは、過去に購入されたユーザーで、新しいデバイスに復元したい方のみが対象です。",
  termOfPotitic: "利用規約・プライバシーポリシー",
  alertDeuErrado: "何かが間違っている :(",
  alertDeuErrado2: "すべての情報を記入する",
  alertNome: "記入欄：名前",
  options: "オプション設定",
  optionsTitle: "オプション設定",
  gradualGame: "段階的な再生",
  textoCaixa:
    "この選択を有効にすると、挑戦は徐々に、つまり、あなたの選択に従って最も軽いものから最も過激なものへと変化します。",
  comoJogar: "遊び方は？ 🤔",
  avalie: "Avalie",
  novaCategoria: "私のカテゴリー",
  alterLanguage: "言語を変更しますか？",
  textLanguage: "言語を変更すると、アプリケーションが再起動します",
  textLanguage1: "言語を変更する",
  cancel: "キャンセル",
  languages: "言語",
  email: "電子メール ✉️",
  deletCat: "カテゴリーを削除する",
  textDeletCat:
    "このカテゴリーを削除すると、このカテゴリーに登録されている課題は削除されます。このアクションの後は、もはや元に戻すことはできません。",
  deletDes: "課題を削除する",
  textDeletDes:
    "課題を削除した後は、この操作を取り消すことができなくなります。",
  desafio: "新規チャレンジの登録",
  desafiotexto: "チャレンジ",
  textoeditDesafio: "誰がそんなことできるんだ",
  textEmquem: "誰に対して？",
  nome: "名称",
  inicio: "ゲームを開始する",
  inicio2: "このボタンを押すと、プレイヤー登録画面になります 👥.",
  inicio3: "いよいよ試合開始 🎲",
  inicio4: "次",
  inicio5: "調整と設定",
  inicio6: `などの調整を行います。
  
- 進歩的な課題
- 挑戦の言葉を変える 
- 課題の創出 
- サポート 
- 中でも`,
  inicio7: "終了",
  inicio8: `プレミアムになると、アクセス権が得られます。

- 450の新たな挑戦😎。

- 専用キャラクター🦸🚒🧑🧑🧑の登場です。
  
- 自分なりの課題を作る 📝。
  
- ゲームを更新し続ける✅。
  
- その他にもいろいろ😍。`,
  inicio9: "ヘルプ",
  inicio10: "ゲーム「Spicy Challenges」へようこそ 🌶",
  inicio11: "30秒以内に再生とメニューの操作ができる簡単さをご覧ください😎。",
  inicio12: "チュートリアルを見る 👍🏼",
  inicio13: "にはしたくない。 👎🏼",
  inicio14: `ゲームを開始するには、最低でも2人のプレイヤーを追加する必要があります😀。
              
  上記で表示しているボタンを押す 👆。
    
  新しいユーザーを追加するたびに、同じボタン😘を押してください。`,
  cadastrarCategory: "カテゴリ登録",
  inicio15: "新規カテゴリーの作成",
  inicio16:
    "Step1：この画面の下にある＋のマークのボタンを押します。を押すと、新しいカテゴリーを入力するためのウィンドウが表示されます。",
  inicio17: "ステップ2：新しいカテゴリーを入力し、保存をクリックします。",
  inicio18:
    "ステップ3：このカテゴリを編集したり、カテゴリ内の課題を追加するには、そのカテゴリをクリックします。",
  inicio19:
    "ステップ4：次の画面で、⬆️の矢印で示されたボタンを押すと、新しいカテゴリーを編集するためのウィンドウが表示されます。",
  inicio20:
    "Step5：次の画面で、矢印⬆️のボタンを押すと、カテゴリが削除されます。",
  inicio21:
    "ステップ1：下のボタンを押して、このカテゴリーに新しい課題を追加する",
  inicio22: "新たな挑戦の創出",
  inicio23:
    "ステップ2：丸で囲った各項目をクリックすると、レジスターの各項目を詳しく知ることができます。",
  inicio24: "挑戦状本文",
  inicio25: `お好きなように課題を書き込んでください。課題にプレイヤー名を表示させるには、下の赤いボタンを押すだけです。
    
  以下の文字が追加されま {nome}. 

** この文字は変更しないでください ** 名前が正しく表示されるためには、以下のようにする必要があります ⬇️⬇️⬇️⬇️。

チャレンジ：首筋にキスを {nome}`,
  inicio26: "挑戦できる人、受けられる人",
  inicio27: `性別が「両方」の参加者が課題を実行・受信できる場合は、「両方」を選択してください。
  
  男女の区別がない場合は、どちらか一方を選択してください。
`,
  inicio28: "チャレンジに時間を加える",
  inicio29:
    "課題に時間がある場合は、下の「範囲」をドラッグするだけで、上に値が表示されます。チャレンジがタイムアップになると、チャレンジ終了を知らせるサウンドが流れます。",
  aviso12: `ここでは、カテゴリーを作成するだけです
    
  課題を追加するには、新しく作成したカテゴリのボタンをクリックするだけです⬆️⬆️⬆️⬆️。`,
  voltar: "背中",
  semDe: "チャレンジ登録のないプレイヤー",
  semDe2: `このプレイヤーへのチャレンジを1つ以上登録する 😬. 
  
  ログイン画面に遷移します。`,
  term: "プライバシー",
  Potitic: "利用規約",
  adquirited: "取得済み",
  camera: "カメラ",
  galery: "ギャラリー",
  avatar: "アバター",
  image: "画像",
  seletion: " 選択された",
  editCategory: "カテゴリーを編集する",
  frase1: "Você está gostando do aplicativo Spicy Challenge?",
  frase2: "プレミアムチャレンジに挑戦してみてはいかがでしょうか。",
  //err texto

  errTexto: "翻訳ミスを発見された方は、以下の欄で文章を修正してください。",
  errTitulo: "何かおかしいところに気づきましたか？",
  errCorrect: "日本語ではどうすべきですか？",
  thisLanguageIsCorrect: "日本語のチャレンジは正しいですか？",
  yes: "はい",
  no: "いいえ",
  errSend: "提案の送信",
  share: "シェア",
  fraseShare: `What a Top app! ただ、あなたも気に入ると思うのでシェアします！🫣。
  ダウンロードしてから、あまり良くないかどうか教えてください(笑)😉。
  
  
  ダウンロード用リンク：https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇯🇵",

  morePlayer: "より多くのプレーヤーと遊ぶには？",
  players: "選手紹介",
  carregar: "画像のアップロード",
  takePhoto: "撮影する、または画像を選択する",
  useAvatar: "またはアバター使用",

  hetero: "ストレート・カップル",
  gay: "ゲイカップル",
  lesbico: "レズビアンカップル",

  nomeHomem1: "男の名前",
  nomeHomem2: "男の名前",
  nomeMulher1: "女性の名前",
  nomeMulher2: "女性の名前",
  messageErr: "選手を追加する 🙌",
  descricaoErr: "参加者の名前を入力する✍️。",
  why: "その理由を教えてください。",
  later: "後で評価する",
  txtCard1: "あなたのターン 🔥",
  txtCard2: "実現させてください😘",
  txtCard3: "さぁ! 😜",
  txtCard4: "「次の挑戦😈」。",
  txtCard5: "もう一回! 👄",

  tituloBloco1Novo: "パートナーとの性的な親密さを深める",
  subtitulo1Novo: "幸せなカップルは100万組以上",
  texto1Novo:
    "あなたとあなたのパートナーの間の親密さを探求し、カップルのための最高のゲームにアクセス！あなたの愛との接続を改善するためにあなたのために設計されたいくつかのカテゴリを持つすべてのゲームを今すぐアンロック！",

  tituloBloco2Novo: "新しい体験とより良い関係",
  texto2Novo1: "「1500以上のチャレンジを楽しむ",
  texto2Novo2: "自分だけの課題を作る",
  texto2Novo3: "専用カテゴリー",
  texto2Novo4: "広告なし",
  texto2Novo5: "専用アバター",
  texto2Novo6: "毎日新しいチャレンジ",
  texto2Novo7: "定期的に更新されるゲーム",
  tituloBloco3Novo: "最高評価を獲得したカテゴリーで",
  tituloBloco4Novo: "人間関係へのメリット",
  texto4Novo1: "親密さ",
  texto4Novo2: "欲望",
  texto4Novo3: "楽しさ",
  texto4Novo4: "魅力",
  texto4Novo5: "つながり",
  texto4Novo6: "快楽",

  tituloBloco5Novo: "カップルの声",
  texto5depoimentoTitulo1: "武田 剣",
  texto5depoimento1:
    "これは今までモバイルで見つけた中で最高のアプリだと思います。エロティックで興味深く、他のアプリとは比べ物になりません。仕事をして購入するべきです。お金がないからと文句を言わないでください。ここでは本当に素晴らしい体験が待っています。たった10ドルでアプリ全体を手に入れられるのですから。地元の大人向けストアのゲームよりも優れた体験を提供しています。",

  texto5depoimentoTitulo2: "佐藤 潤",
  texto5depoimento2:
    "このアプリは本当に素晴らしいです！ダウンロードするか迷っていましたが、最近で一番の体験になりました。一緒にまだたくさんのことができると感じられるのは本当に嬉しいことです。🤭 有料版を試しましたが、本当に価値があります。これまでこのレベルの快感は味わったことがありませんでした。",

  texto5depoimentoTitulo3: "中村 美咲",
  texto5depoimento3:
    "関係を盛り上げたいなら、このアプリは完璧です！他のアプリも試したことがありますが、これほど満足できたものはありませんでした。前戯がより熱く、楽しいものになりました（その後は想像にお任せします！）。より強い快感を求めるなら、有料版を購入する価値がありますが、無料版も十分驚かされました。",

  texto5depoimentoTitulo4: "山田 杏奈",
  texto5depoimento4:
    "素晴らしい！本当に最高です... ゲーム中にとても興奮し、セックスがさらに刺激的で楽しいものになりました。快感がそこら中に広がっていました！またすぐにプレイするのが待ちきれません 💦🔥 有料版もおすすめします。興奮を抑えられるなら、ぜひ試してみてください 🤤",
  tituloBloco6Novo:
    "世界中の何百ものカップルのように、あなたの関係をより良いものにしましょう。800以上の新しい課題を発見してください。チャレンジ！",
  texto6Select: "バージョンを選択します。",
  texto6Premium: "Premium",
  texto6Assinatura: "署名",
  texto6Mensal: "マンスリーサブスクリプション",
  texto6Anual: "ねんぷく",
  texto6Vitalicia: "ライフタイムサブスクリプション",
  bePremium: "プレミアムに登録する",
  buyNew: "購入",
  attention: "ご注意ください",
  changeGender: "あなたの性的指向が変わりました。",

  tituloAvaliacao: "ゲームを楽しんでいますか？",
  textoAvaliacao: "評価して、私たちの改善をお手伝いください！",
  agoraNão: "今はいりません",
  enviarAvaliacao: "送信",

  nomeJogo1: "刺激的な挑戦",
  nomeJogo2: "真実か挑戦か",
  nomeJogo3: "いたずらレベル",
  nomeJogo4: "セクシールーレット",
  nomeJogo5: "今日の一言",
  naughtyQuiz: "いたずらなクイズ",

  playAlone: "ひとりで遊ぶ",
  estaSozinho: "ひとりですか？",
  selectPlayer: "プレイヤーを選択",

  skip: "スキップ",
  responder: "送信",
  respondaAqui: "こちらに回答",
  config4: "アバターを選んでカスタマイズ",

  tituloSelect1: "ひとりでプレイ？",
  tituloSelect2: "恥ずかしい質問に答える！",

  subTituloSelect1: "手伝います！",
  subTituloSelect2: "あなたがどれだけいたずらなのかを発見！",
  txtJogador1:
    "プレイヤーを選んで、あなただけのために設計されたガイド付きの一人プレイを楽しんでください！",
  txtJogador2: "選択したプレイヤーが質問に答えます",
  tituloCena: "どのアイテムを使用しますか？",
  subTituloCena:
    "持っていない？「取得」をタップして提携ストアで購入してください。",
  play: "プレイ",

  titleUserWarning: "ユーザーを選択",
  txtUserWarning: "質問に答えるユーザーを選択",

  shareNivelDeSafadeza:
    "ねえ、私のいたずらレベルをチェックしてみてください 😈 強烈な快楽の瞬間を体験してください。あなたも 💋 今すぐアプリをダウンロードして、パートナーとのエキサイティングな挑戦 🔥 に備えてください：➡️ https://spicychallengesapp.page.link/sharelevelhot",

  shareDica:
    "今すぐ恋愛を変えよう！アプリをダウンロードして、スパイシーな関係の秘密を発見しよう：➡️ https://spicychallengesapp.page.link/tipoftheday",

  resultadoQuiz1:
    "あなたは控えめな性格で、セクシャルなことよりもロマンチックなことを好みます。",
  resultadoQuiz2:
    "あなたはセクシャルなことを過度に楽しむことはなく、ろうそくの明かりの雰囲気を楽しむことが多いです。",
  resultadoQuiz3:
    "あなたは非常に控えめな性格で、プライバシーを保つことを大切にしています。",
  resultadoQuiz4:
    "これは、時折セクシーにならないわけではないことを意味しますが、その情熱を特別な誰かと共有するのを好むことを意味します。",
  resultadoQuiz5:
    "あなたの情熱は二次的であるかもしれませんが、その情熱がないということは変わりません。",
  resultadoQuiz6:
    "あなたは新しい経験を探求することを好みますが、常に尊重と同意を大切にします。",
  resultadoQuiz7:
    "あなたはキスや情熱的な出会いが大好きです。しかし、恋人と手をつないで映画を見たり、キャンドルの灯りの中でディナーを楽しむ側面もあります。",
  resultadoQuiz8:
    "あなたは新しい刺激的なことを試す意欲がありますが、常に責任を持って行動します。",
  resultadoQuiz9: "あなたは大胆で、時折性の面で事を刺激したいと考えています。",
  resultadoQuiz10:
    "あなたは人生のあらゆる喜びを楽しむのが好きで、セックスに関しては制約がありません。",
  resultadoQuiz11:
    "あなたと一緒にいると退屈な時間はありません。恋愛映画？それなら「フィフティ・シェイズ・オブ・グレイ」しかありません！",
  resultadoQuiz12:
    "あなたにとって、親密さは絶え間ない冒険であり、リスクを恐れることはありません。",
  mes: "月",
  desafiosRestantesDois: "プレミアムチャレンジがあと2つ残っています！",
  nenhumDesafioRestante: "プレミアムチャレンジはもう残っていません！",
  tornePremiumAviso1:
    "今すぐプレミアムになって、1000のエクスクルーシブチャレンジをお楽しみください！",
  tornePremiumAviso2:
    "無制限のチャレンジ、限定コンテンツ、途切れない楽しさをお楽しみください！",
  conteudoPremium: "プレミアムコンテンツを選択しました！",
  aproveite4desafios:
    "エクスクルーシブな喜びを味わうために、プレミアムチャレンジ4つをお楽しみください。",
  calculando: "結果を計算中...",
  nivelRomantismo: "あなたのロマンスレベルは...",
  finalizar: "終わり",
  erroQuizTitulo: "回答を入力してください",
  erroQuizFrase: "進むには回答を入力してください！",
  new: "新しいアプリ",

  //resposta quiz safadeza

  resQuiz1: "穏やか",
  resQuiz2: "情熱的",
  resQuiz3: "魅力的",
  resQuiz4: "超いたずらっ子",

  texto6Semanal: "週次",
  weekly: "週次署名",

  tempSemanal: "毎週請求",
  tempMensal: "毎月請求",
  tempAnual: "年間請求",
  tempSempre: "一度の支払い",
  canceleAny: "いつでもキャンセル",

  //Tela do safadrometro
  Low: "低」",
  Medium: "中",
  High: "高",

  lifeTime: "ライフタイムアクセス",
  notNow: "今はいいです、ありがとう。",
  match: "A.I.とマッチするアプリ",

  //Modal date
  dateTitle: "新しいアプリをチェックしてみませんか？",

  dateBody: `いたずらな 😈 ボットとチャットしたり、口説きの練習をしたりしたいですか？楽しめること間違いなし！🔥`,
  goToDate: "今すぐ Date.AI を試してみる！",
  goodForU: "あなたにとって良かったですか？",
  rateOurPerformance: "これまでのパフォーマンスを評価してください",
  veryGood: "とても良い",
  veryBad: "とても悪い",
  feedbackChallenge: `他のカップルとHot Challengesアプリを共有したくなる理由とその理由は何ですか？`,
  type: "答えを入力してください...",
  survey: "満足度調査。",
  shareIfConfortable: `気軽に友達と共有してくださいね :)`,

  howToPlay: "遊び方",
  howToPlayHotChallenge:
    "準備はいいですか？チャレンジカードを引いて、熱いアクションでパートナーを驚かせましょう！",

  preGameTip1: "欲望を解き放ち、パートナーと忘れられない瞬間を作りましょう！",
  preGameTip2: "あなたの情熱を燃やし、一緒に忘れられない瞬間を作りましょう！",
  preGameTip3: "最も大胆な欲望を探求し、忘れられない思い出を作りましょう！",
  preGameTip4:
    "あなたのファンタジーを解き放ち、純粋な快楽の瞬間を楽しんでください！",
  selecionajoagador: "遊ぶ時間だ",
  dica: "ヒント",

  howToPlayNaughty:
    "お気に入りのおもちゃやアイテムを選んでください。ルーレットを回して、次の大胆な挑戦を運命に任せましょう！",
  howToPlayTruthOrDare:
    "運命を選んで：真実を話すか、大胆なチャレンジに挑むか。さあ、楽しみましょう！",
  howToKama1: "喜びのポジションを発見 – 365日間の情熱！",
  howToKama2:
    "ランダムなカードを引いて、ポジションを試し、共に新しい快感の高みを探検しましょう！",
  kamaExplain:
    "毎日新しいポジションをアンロックして、究極の情熱コレクションを作りましょう。365日忘れられない快感の旅がここから始まります！",
  howToDo: "やり方",
  pergunta: "質問",
  restart: "再起動",
  dialogText1HotChallenges:
    "選択されたカテゴリーで利用可能なすべてのチャレンジを完了しました。",
  dialogText2HotChallenges:
    "さらにカテゴリーを選択するか、現在のチャレンジでゲームを再起動してください！",
  noChallenges: "チャレンジなし！",

  objects: "オブジェクト",
  dialogText1NaughtyGames:
    "選択したオブジェクトで利用可能なすべてのチャレンジを完了しました。",
  dialogText2NaughtyGames:
    "さらにオブジェクトを選択するか、現在のチャレンジでゲームを再開してください！",
  unlockPremium: "プレミアムをアンロック",
  noCategory: "開始するには、少なくとも1つのカテゴリーを選んでください。",
  thanksForFeedback: "体験を改善するためにご協力いただきありがとうございます！",
  categoryKamasutra: "あなたの情熱を選んで、楽しんで！",
  tap: "タップしてポジションを明かそう！",
  step: "ステップバイステップガイド",
  shareQuizButton: "あなたのやんちゃレベルをシェアしよう！",
  tryAgain: "もう一度試してください",
  unlockAllFun: "すべての楽しさをアンロック",
  limitedOffer: "期間限定の特別オファー！",
  fill: "あなたとパートナーの名前を入力してください。",

  kamaNotificationTitle: "🔥 あなたの新しいカードが解放されました！",
  kamaNotificationBody:
    "あなたの{variavel}日目のポジションが準備できました。今日は新しいことに挑戦しませんか？💋",

  titleNewGame: "ロールプレイの準備を！",
  phraseNewGame:
    "次回のアップデートで、あなたの最もクリエイティブなファンタジーを探求する新しいゲームが登場します。キャラクターを選び、ストーリーを作成し、パートナーと一緒に楽しみを新たなレベルへと引き上げましょう。🔥",
  awaitNewGame: "ユニークな瞬間を迎える準備をしてください！",

  selectObjects:
    "2つ以上のアイテムを選んでゲームをカスタマイズしましょう。最大限に楽しんでください。",
  soon: "近日公開",
  wantToBeNotify: "通知を受け取りたい",
  ok: "オーケー",
  vezDe: "ターン",

  categoryLabel: "カテゴリー",
  descriptionLabel: "説明",

  loginConnect: "ログイン",
  loginNoAccount: "アカウントを持っていない？",
  loginCreateNow: "今すぐ作成",
  loginOrConnect: "または接続",

  email: "メール",
  password: "パスワード",
  loginRegister: "登録",
  loginAlreadyHas: "既にアカウントを持っている？",
  enterNow: "今すぐログイン",

  logout: "ログアウト",
  customerPortal: "顧客ポータル",
  installApp: "アプリをインストール",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/japones.mp4",
};
